import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { DefaultFilter } from '../../teams/default-filters/default-filter.interface';
import { DefaultFilterService } from './default-filter.service';

const service = new DefaultFilterService();

export interface DefaultFilterState {}

const DefaultFilterStore: Module<DefaultFilterState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getDefaultFilter(context, clusterId: number) {
         const response = await service.getDefaultFilter(clusterId);
         return response.data;
      },

      async postDefaultFilter(context, { clusterId, defaultFilters }: { clusterId: number; defaultFilters: Array<DefaultFilter> }) {
         const response = await service.postDefaultFilter(clusterId, defaultFilters);
         return response;
      },

      async deleteDefaultFilterTeams(context, clusterId: number) {
         const response = await service.deleteDefaultFilterTeams(clusterId);
         return response;
      },
   },
};

export default DefaultFilterStore;
